import { LoadedState } from "../../loader";
import { SDFQuad } from "./SDFQuad";
import * as fs from "fs";

export class MainShader extends SDFQuad {
  constructor(gl: WebGL2RenderingContext, resources: LoadedState) {
    const sdfVertexShader = fs.readFileSync(__dirname + "/main.vert", "utf8");
    const sdfFragmentShader = fs.readFileSync(__dirname + "/main.frag", "utf8");

    super(gl, resources, sdfVertexShader, sdfFragmentShader);

    this.addTextureUniform("textureMetal", resources.textures.metal);
    this.addTextureUniform(
      "textureMetalNormal",
      resources.textures.metalNormal,
    );
  }
}
